import React from 'react';
import {useIntl} from 'react-intl';
import SACheckbox from '../../common/input/SACheckbox';
import SADropdown from '../../common/dropdown/SADropdown';
import {withAuthorizationV2} from '../../../services/Authorization';
import Time from '../../../services/Time';

const AvailabilityStart = ({availabilities, error, onDateChange, onTimeChange, onTwentyFourChange, selectedDates}) => {
  const intl = useIntl();

  const startDates = availabilities.map(a => a.day);
  const selectedDay = availabilities.find(a => a.day === selectedDates.startDate) || {slots: []};

  if (!startDates.includes(selectedDates.startDate)) {
    startDates.push(selectedDates.startDate);
  }

  const startTimes = selectedDay.slots;
  if (selectedDates.startTime && !startTimes.includes(selectedDates.startTime)) { // sometimes there aren't any slots for days with 24/7 enabled
    startTimes.push(selectedDates.startTime);
  }

  startDates.sort();
  startTimes.sort();

  return (
    <div className="form-field row">
      <ul className="list col-md-5 col-xxl-5 ">
        <label>{intl.formatMessage({id: 'placeholder.startDate'})}</label>
        <SADropdown name="startDate" value={selectedDates.startDate}
                    choices={startDates.map(d => ({value: d, display: Time.dateFromApiToDisplay(d)}))} onChange={onDateChange}
                    error={error}/>
      </ul>
      <ul className="list col-md-5 col-xxl-5 ">
        <label>{intl.formatMessage({id: 'placeholder.startTime'})}</label>
        <SADropdown name="startTime" value={selectedDates.startTime}
                    choices={startTimes.map(t => ({value: t, display: Time.timeFromApiToDisplay(t)}))} onChange={onTimeChange}
                    disabled={!selectedDates.duringWorkingHours || startTimes.length === 0}
                    error={error}/>
      </ul>
      {selectedDay.twentyFourSevenAvailable &&
        <ul className="list col-md-2 col-xxl-2 ">
          <label>{intl.formatMessage({id: '24/7'})}</label>
          <SACheckbox name="duringWorkingHours" checked={!selectedDates.duringWorkingHours}
                      onChange={onTwentyFourChange}
                      error={error}/>
        </ul>
      }
    </div>
  )
}

export default withAuthorizationV2(AvailabilityStart, ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']);
